<dx-popup
  [width]="'70%'"
  [maxWidth]="620"
  [(visible)]="showModal"
  [height]="'480px'"
  [showTitle]="false"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
>
  <div class="popup-content">
    <p class="title">{{ "TRAINING-WAITING-LIST.OVERVIEW.TITLE" | translate }}</p>
    <p class="description">{{ "TRAINING-WAITING-LIST.OVERVIEW.TEXT" | translate }}</p>
    <p>{{ "TRAINING-WAITING-LIST.OVERVIEW.CONFIRMATION-INFO" | translate }}</p>
    <div class="button-container">
      <dx-button 
        [text]="'COMMON.CANCEL' | translate" 
        type="default"
        [width]="'220px'"
        (onClick)="cancel()"
      ></dx-button>
      <dx-button 
        [text]="'MY-TRAININGS.TRAINING-QUEUE.ADD-ME-TO-QUEUE' | translate" 
        type="normal"
        stylingMode="contained"
        [width]="'220px'"
        (onClick)="send()"
      ></dx-button>
    </div>
  </div>
</dx-popup>